import MessageScheduler from "../../components/MessageScheduler";

export default function ScheduledMessages() {
  return <MessageScheduler/>;
}